import moment from 'moment/moment';
import { FormattedMessage } from 'react-intl';
import { YES_NO_OPTIONS, YES_UPDATE_OPTIONS } from 'utils/constants';
import { getDefaultValues } from 'pages/AffordaWagesAndIncome/utils.jobs';
import { WAGES_AND_INCOME_COMMON_FIELD_NAMES } from 'pages/AffordaWagesAndIncome/constants.fields';
import { PAY_FREQUENCY } from 'pages/AffordaWagesAndIncome/constants';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.job.title',
  description: 'afforda.wagesAndIncome.details.job.subtitle',
  addButton: 'afforda.wagesAndIncome.details.job.addEmployment',
  addCaption: 'afforda.wagesAndIncome.details.job.addEmployment.subtitle',
};

export const JOB_FIELD_NAMES = {
  annualNet: 'annualNet',
  annualPay: 'annualPay',
  anticipatedIncrease12Months: 'anticipatedIncrease12Months',
  anticipatedIncreaseRate: 'anticipatedIncreaseRate',
  anticipatedIncreaseUpdate: 'anticipatedIncreaseUpdate',
  anticipatedIncreaseWhen: 'anticipatedIncreaseWhen',
  averageNet: 'averageNet',
  basePayLongevity: 'basePayLongevity',
  biWeeklyPay: 'biWeeklyPay',
  bonusOrCommissions: 'bonusOrCommissions',
  city: 'city',
  commissionsOrBonuses: 'commissionsOrBonuses',
  commissionsOrBonusesType: 'commissionsOrBonusesType',
  commissionsPayFrequency: 'commissionsPayFrequency',
  commissionsPayFrequencyAnnually: 'commissionsPayFrequencyAnnually',
  commissionsPayFrequencyMonthly: 'commissionsPayFrequencyMonthly',
  commissionsPayFrequencyWeekly: 'commissionsPayFrequencyWeekly',
  employerName: 'employerName',
  endDate: 'endDate',
  doNotWorkEndDate: 'doNotWorkEndDate',
  doNotWorkEndDate2: 'doNotWorkEndDate2',
  doNotWorkStartDate: 'doNotWorkStartDate',
  doNotWorkStartDate2: 'doNotWorkStartDate2',
  employmentType: 'employmentType',
  foreignDuty: 'foreignDuty',
  hourlyPay: 'hourlyPay',
  hoursPerWeek: 'hoursPerWeek',
  layoffPeriod: 'layoffPeriod',
  memberId: 'memberId',
  memberName: 'memberName',
  militaryBranch: 'militaryBranch',
  monthlyPay: 'monthlyPay',
  numDependents: 'numDependents',
  numDependentsClaimed: 'numDependentsClaimed',
  overtimeAvgHours: 'overtimeAvgHours',
  overtimeHourRate: 'overtimeHourRate',
  overtimePay: 'overtimePay',
  payFrequency: 'payFrequency',
  position: 'position',
  proficiency: 'proficiency',
  proficiencyPay: 'proficiencyPay',
  quarters: 'quarters',
  quartersAllowance: 'quartersAllowance',
  receiveTipsAvgWeek: 'receiveTipsAvgWeek',
  receiveTipsAvgUnreported: 'receiveTipsAvgUnreported',
  seaAndForeignDutyPay: 'seaAndForeignDutyPay',
  seasonalWorkWeeks: 'seasonalWorkWeeks',
  selfTaxes: 'selfTaxes',
  semiMonthlyPay: 'semiMonthlyPay',
  startDate: 'startDate',
  state: 'state',
  streetAddress: 'streetAddress',
  subsistence: 'subsistence',
  subsistenceAllowance: 'subsistenceAllowance',
  supervisorName: 'supervisorName',
  supervisorPhone: 'supervisorPhone',
  tipsAndGratuities: 'tipsAndGratuities',
  tipsAndGratuitiesAllReported: 'tipsAndGratuitiesAllReported',
  tipsAndGratuitiesPerWeek: 'tipsAndGratuitiesPerWeek',
  tipsAndGratuitiesUnreportedByWeek: 'tipsAndGratuitiesUnreportedByWeek',
  totalIncome: 'totalIncome',
  weeklyPay: 'weeklyPay',
  workType: 'workType',
  zipCode: 'zipCode',
};

export const NEW_MEMBER_JOB = getDefaultValues({});

export const GridProps = {
  xs: 12,
  sm: 6,
  md: 6,
};

export const SMALL_GRID_PROPS = {
  xs: 12,
  sm: 6,
};

export const FIELD_TEXT_REQUIRED = {
  variant: 'text',
  GridProps: {
    xs: 12,
  },
  rules: {
    required: true,
    validate: validateNoSpecialChars,
  },
};

export const FIELD_COUNTER_REQUIRED = {
  variant: 'counter',
  GridProps: {
    xs: 12,
  },
  rules: {
    required: true,
    min: 0,
  },
};

export const FIELD_GROUP_BUTTONS = {
  variant: 'buttonGroup',
  direction: 'row',
  rules: {
    required: true,
  },
  GridProps: {
    xs: 12,
  },
  sx: {
    flexWrap: 'wrap',
    width: '100%',
    '& > button': {
      width: { xs: 'calc(50% - 4px)', sm: 'calc(33% - 4px)' },
    },
  },
};

export const FIELD_YES_UPDATE = {
  variant: 'buttonGroup',
  rules: {
    required: true,
  },
  options: YES_UPDATE_OPTIONS,
  direction: 'row',
  GridProps: {
    xs: 12,
  },
  sx: {
    flexWrap: 'wrap',
    width: '100%',
    '& > button': {
      width: { xs: 'calc(50% - 4px)', sm: 'calc(33% - 4px)' },
    },
  },
};

export const FIELD_YES_NO = {
  variant: 'buttonGroup',
  rules: {
    required: true,
  },
  options: YES_NO_OPTIONS,
  direction: 'row',
  GridProps: {
    xs: 12,
  },
};

export const FIELD_AMOUNT = {
  variant: 'number',
  GridProps,
  rules: {
    max: 499999.99,
    min: 0,
    step: 0.01,
    required: true,
  },
  adornment: '$',
};

export const FIELD_DATE = {
  variant: 'date',
  defaultCalendarMonth: moment(2000, 'YYYY'),
  InputLabelProps: {
    sx: {
      width: '100%',
      whiteSpace: 'normal',
    },
  },
};

export const EMPLOYMENT_TYPE = {
  fullTime: 'f_t_et',
  selfEmployed: 's_e_et',
  military: 'm_et',
  partTime: 'p_t_et',
  seasonal: 's_et',
};

export const EMPLOYMENT_TYPE_OPTIONS = {
  FULL_TIME: {
    value: EMPLOYMENT_TYPE.fullTime,
    text: 'afforda.wagesAndIncome.details.job.fullTime',
  },
  SELF_EMPLOYED: {
    value: EMPLOYMENT_TYPE.selfEmployed,
    text: 'afforda.wagesAndIncome.details.job.selfEmployed',
  },
  MILITARY: {
    value: EMPLOYMENT_TYPE.military,
    text: 'afforda.wagesAndIncome.details.job.military',
  },
  PART_TIME: {
    value: EMPLOYMENT_TYPE.partTime,
    text: 'afforda.wagesAndIncome.details.job.partTime',
  },
  SEASONAL: {
    value: EMPLOYMENT_TYPE.seasonal,
    text: 'afforda.wagesAndIncome.details.job.seasonal',
  },
};

export const PAY_FREQUENCY_OPTIONS = {
  HOURLY: {
    value: PAY_FREQUENCY.hourly,
    text: 'afforda.wagesAndIncome.details.job.hourly',
  },
  WEEKLY: {
    value: PAY_FREQUENCY.weekly,
    text: 'afforda.wagesAndIncome.details.job.weekly',
  },
  BI_WEEKLY: {
    value: PAY_FREQUENCY.biweekly,
    text: 'afforda.wagesAndIncome.details.job.biweekly',
  },
  SEMI_MONTHLY: {
    value: PAY_FREQUENCY.semimonthly,
    text: 'afforda.wagesAndIncome.details.job.semimonthly',
  },
  MONTHLY: {
    value: PAY_FREQUENCY.monthly,
    text: 'afforda.wagesAndIncome.details.job.monthly',
  },
  ANNUALLY: {
    value: PAY_FREQUENCY.annually,
    text: 'afforda.wagesAndIncome.details.job.annually',
  },
};

export const PAY_FREQUENCY_COMMISSION_OPTIONS = {
  WEEKLY: {
    value: PAY_FREQUENCY.weekly,
    text: 'afforda.wagesAndIncome.details.job.weekly',
  },
  MONTHLY: {
    value: PAY_FREQUENCY.monthly,
    text: 'afforda.wagesAndIncome.details.job.monthly',
  },
  ANNUALLY: {
    value: PAY_FREQUENCY.annually,
    text: 'afforda.wagesAndIncome.details.job.annually',
  },
};

export const MILITARY_BRANCHES_OPTIONS = {
  AIR_FORCE: {
    value: 'airForce',
    text: 'afforda.wagesAndIncome.details.job.military.airForce',
  },
  MARINES: {
    value: 'marines',
    text: 'afforda.wagesAndIncome.details.job.military.marines',
  },
  SPACE_FORCE: {
    value: 'spaceForce',
    text: 'afforda.wagesAndIncome.details.job.military.spaceForce',
  },
  RESERVES: {
    value: 'reserves',
    text: 'afforda.wagesAndIncome.details.job.military.reserves',
  },
  ARMY: {
    value: 'army',
    text: 'afforda.wagesAndIncome.details.job.military.army',
  },
  NAVY: {
    value: 'navy',
    text: 'afforda.wagesAndIncome.details.job.military.navy',
  },
  COAST_GUARD: {
    value: 'coastGuard',
    text: 'afforda.wagesAndIncome.details.job.military.coastGuard',
  },
  NATIONAL_GUARD: {
    value: 'nationalGuard',
    text: 'afforda.wagesAndIncome.details.job.military.nationalGuard',
  },
};

export const MILITARY_BRANCHES_OPTIONS_MAP = {
  airForce: MILITARY_BRANCHES_OPTIONS.AIR_FORCE,
  marines: MILITARY_BRANCHES_OPTIONS.MARINES,
  spaceForce: MILITARY_BRANCHES_OPTIONS.SPACE_FORCE,
  reserves: MILITARY_BRANCHES_OPTIONS.RESERVES,
  army: MILITARY_BRANCHES_OPTIONS.ARMY,
  navy: MILITARY_BRANCHES_OPTIONS.NAVY,
  coastGuard: MILITARY_BRANCHES_OPTIONS.COAST_GUARD,
  nationalGuard: MILITARY_BRANCHES_OPTIONS.NATIONAL_GUARD,
};

export const LAYOFF_PERIOD_OPTIONS = {
  UNEMPLOYMENT_BENEFITS: {
    value: 'unemploymentBenefits',
    text: 'afforda.wagesAndIncome.details.job.layoffPeriod.benefits',
  },
  LOOK_FOR_ANOTHER_JOB: {
    value: 'lookForAnotherJob',
    text: 'afforda.wagesAndIncome.details.job.layoffPeriod.another',
  },
  GIFTED_INCOME: {
    value: 'giftedIncome',
    text: 'afforda.wagesAndIncome.details.job.layoffPeriod.gifted',
  },
  NO_SOURCE_OF_INCOME: {
    value: 'noSourceOfIncome',
    text: 'afforda.wagesAndIncome.details.job.layoffPeriod.source',
  },
  OTHER: {
    value: 'other',
    text: 'afforda.wagesAndIncome.details.other',
  },
};

export const BONUS_COMMISSION_OPTIONS = {
  COMMISSSION: {
    value: 'jobCommission',
    text: 'afforda.wagesAndIncome.details.job.commission',
  },
  BONUS: {
    value: 'jobBonus',
    text: 'afforda.wagesAndIncome.details.job.bonus',
  },
};

export const FIELD_SHOW_COMMON = {
  watchFields: [JOB_FIELD_NAMES.memberId],
  hidden: ({ getValues }) => !getValues(JOB_FIELD_NAMES.memberId)?.length,
};

export const FIELD_SHOW_IF_EMPLOYMENT_TYPE_IS_SELECTED = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues([
      JOB_FIELD_NAMES.memberId,
      JOB_FIELD_NAMES.employmentType,
    ]).every((value) => Boolean(value?.length)),
};

export const FIELD_SHOW_MILITARY = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) !== EMPLOYMENT_TYPE.military,
};

export const FIELD_SHOW_NO_MILITARY = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.employmentType)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) === EMPLOYMENT_TYPE.military,
};

export const FIELD_SHOW_NO_MILITARY_OR_SELF_EMPLOYED = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.employmentType)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) === EMPLOYMENT_TYPE.military ||
    getValues(JOB_FIELD_NAMES.employmentType) === EMPLOYMENT_TYPE.selfEmployed,
};

export const FIELD_SHOW_SELF_EMPLOYED = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.employmentType)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) !== EMPLOYMENT_TYPE.selfEmployed,
};

export const FIELD_SHOW_NO_SELF_EMPLOYED = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.employmentType)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) === EMPLOYMENT_TYPE.selfEmployed,
};

export const FIELD_SHOW_NO_MILITARY_NO_SELFEMPLOYED_PAYRATE = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.employmentType,
    JOB_FIELD_NAMES.payFrequency,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) ===
      EMPLOYMENT_TYPE.selfEmployed ||
    getValues(JOB_FIELD_NAMES.employmentType) === EMPLOYMENT_TYPE.military ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length,
};

export const FIELD_SHOW_SEASONAL = {
  watchFields: [JOB_FIELD_NAMES.memberId, JOB_FIELD_NAMES.employmentType],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.employmentType) !== EMPLOYMENT_TYPE.seasonal,
};

export const FIELD_SHOW_PAY_HOURLY_SEMI_OR_BIWEEKLY = {
  watchFields: [JOB_FIELD_NAMES.payFrequency],
  hidden: ({ getValues }) =>
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.hourly &&
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.semimonthly &&
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.biweekly,
};

export const FIELD_SHOW_PAY_MONTHLY = {
  watchFields: [JOB_FIELD_NAMES.payFrequency],
  hidden: ({ getValues }) =>
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.monthly,
};

export const FIELD_SHOW_PAY_WEEKLY = {
  watchFields: [JOB_FIELD_NAMES.payFrequency],
  hidden: ({ getValues }) =>
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.weekly,
};

export const FIELD_SHOW_PAY_ANNUALLY = {
  watchFields: [JOB_FIELD_NAMES.payFrequency],
  hidden: ({ getValues }) =>
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.annually,
};

export const FIELD_SHOW_ANTICIPATED12 = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_HOURLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.hourly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_HOURLY_UPDATE = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
    JOB_FIELD_NAMES.anticipatedIncreaseRate,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.hourly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.anticipatedIncreaseRate)?.length,
};

export const FIELD_SHOW_ANTICIPATED12_HOURLY_UPDATE_WHEN = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
    JOB_FIELD_NAMES.anticipatedIncreaseRate,
    JOB_FIELD_NAMES.anticipatedIncreaseUpdate,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.hourly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.anticipatedIncreaseRate)?.length ||
    getValues(JOB_FIELD_NAMES.anticipatedIncreaseUpdate) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_ANNUAL = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.annually ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_WEEKLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.weekly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_BIWEEKLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.biweekly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_SEMI_MONTHLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.semimonthly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_ANTICIPATED12_MONTHLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.anticipatedIncrease12Months,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    getValues(JOB_FIELD_NAMES.payFrequency) !== PAY_FREQUENCY.monthly ||
    getValues(JOB_FIELD_NAMES.anticipatedIncrease12Months) !== 'yes',
};

export const FIELD_SHOW_OVERTIME_PAY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.overtimePay,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.overtimePay) !== 'yes',
};

export const FIELD_SHOW_TIPS_PAY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.tipsAndGratuities,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.tipsAndGratuities) !== 'yes',
};

export const FIELD_SHOW_TIPS_UNREPORTED = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.tipsAndGratuities,
    JOB_FIELD_NAMES.tipsAndGratuitiesAllReported,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.tipsAndGratuities) !== 'yes' ||
    getValues(JOB_FIELD_NAMES.tipsAndGratuitiesAllReported) !== 'no',
};

export const FIELD_SHOW_COMMISSIONS_PAY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.commissionsOrBonuses,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsOrBonuses) !== 'yes',
};

export const FIELD_SHOW_COMMISSIONS_SPECIFIED = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.commissionsOrBonuses,
    JOB_FIELD_NAMES.bonusOrCommissions,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsOrBonuses) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.bonusOrCommissions)?.length,
};

export const FIELD_SHOW_COMMISSIONS_PAY_WEEKLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.commissionsOrBonuses,
    JOB_FIELD_NAMES.bonusOrCommissions,
    JOB_FIELD_NAMES.commissionsPayFrequency,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsOrBonuses) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.bonusOrCommissions)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsPayFrequency) !== PAY_FREQUENCY.weekly,
};

export const FIELD_SHOW_COMMISSIONS_PAY_MONTHLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.commissionsOrBonuses,
    JOB_FIELD_NAMES.bonusOrCommissions,
    JOB_FIELD_NAMES.commissionsPayFrequency,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsOrBonuses) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.bonusOrCommissions)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsPayFrequency) !==
      PAY_FREQUENCY.monthly,
};

export const FIELD_SHOW_COMMISSIONS_PAY_ANNUALLY = {
  watchFields: [
    JOB_FIELD_NAMES.memberId,
    JOB_FIELD_NAMES.payFrequency,
    JOB_FIELD_NAMES.commissionsOrBonuses,
    JOB_FIELD_NAMES.bonusOrCommissions,
    JOB_FIELD_NAMES.commissionsPayFrequency,
  ],
  hidden: ({ getValues }) =>
    !getValues(JOB_FIELD_NAMES.memberId)?.length ||
    !getValues(JOB_FIELD_NAMES.payFrequency)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsOrBonuses) !== 'yes' ||
    !getValues(JOB_FIELD_NAMES.bonusOrCommissions)?.length ||
    getValues(JOB_FIELD_NAMES.commissionsPayFrequency) !==
      PAY_FREQUENCY.annually,
};

export const FIELD_SEASONAL_WORK_DATES = {
  ...FIELD_SHOW_SEASONAL,
  variant: 'date',
  label: <FormattedMessage id="afforda.wagesAndIncome.details.job.doNotwork" />,
  name: JOB_FIELD_NAMES.doNotWorkStartDate,
  defaultCalendarMonth: moment(2000, 'YYYY'),
  rules: {
    maxDate: moment().endOf('year'),
    required: true,
  },
  GridProps: SMALL_GRID_PROPS,
  helperText: null,
};

export const ADDRESS_FIELDS = ({ intl, states, validateZip, ...props }) => [
  {
    ...FIELD_TEXT_REQUIRED,
    ...FIELD_SHOW_IF_EMPLOYMENT_TYPE_IS_SELECTED,
    variant: 'address',
    label: <FormattedMessage id="app.label.streetAddress" />,
    placeholder: intl?.formatMessage?.({
      id: 'app.label.streetAddress',
    }),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.streetAddress,
    ...props,
  },
  {
    ...FIELD_TEXT_REQUIRED,
    ...FIELD_SHOW_IF_EMPLOYMENT_TYPE_IS_SELECTED,
    label: <FormattedMessage id="app.label.city" />,
    placeholder: intl?.formatMessage?.({
      id: 'app.label.city',
    }),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.city,
    ...props,
  },
  {
    ...FIELD_SHOW_IF_EMPLOYMENT_TYPE_IS_SELECTED,
    variant: 'singleSelect',
    label: <FormattedMessage id="app.label.stateOrProvince" />,
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.state,
    rules: {
      required: true,
    },
    GridProps,
    options: states?.map((state) => ({
      value: state.code,
      text: state.name,
    })),
    ...props,
  },
  {
    ...FIELD_SHOW_IF_EMPLOYMENT_TYPE_IS_SELECTED,
    variant: 'number',
    label: <FormattedMessage id="app.label.zip" />,
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.zipCode,
    rules: {
      required: true,
      validate: validateZip,
      minLength: 5,
      maxLength: 5,
    },
    GridProps,
    placeholder: intl?.formatMessage?.({
      id: 'app.label.zip',
    }),
    ...props,
  },
];
